import { useEffect, useState } from "react";
import QRCode from "qrcode";

type QrPreviewProps = {
  value: string;
  size?: number;
};

export function QrPreview({ value, size = 112 }: QrPreviewProps) {
  const [src, setSrc] = useState("");

  useEffect(() => {
    let active = true;

    QRCode.toDataURL(value, {
      width: size * 2,
      margin: 1,
      color: {
        dark: "#121815",
        light: "#ffffff",
      },
      errorCorrectionLevel: "M",
    }).then((result) => {
      if (active) {
        setSrc(result);
      }
    });

    return () => {
      active = false;
    };
  }, [size, value]);

  return (
    <div className="qr-preview" style={{ width: size, height: size }}>
      {src ? <img src={src} alt="当前 Qode 二维码预览" /> : null}
      <span className="qr-center" aria-hidden="true">
        Q
      </span>
    </div>
  );
}
